<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :append-to-body="true"
        :title="titleDialog"
        :close-on-click-modal="false"
        :before-close="close"
        :width="windowWidth > 500 ? '60%': '90%'"
    >
        <div
            v-if="context"
            class="edit-user"
        >
            <div>
                <form-edit-user
                    v-if="dialogVisible"
                    ref="formEditUser"
                    :window-width="windowWidth"
                    :user="context.user"
                    :is-edit="isEdit"
                    :current-user="$store.getters.currentUser"
                    :groups="groups"
                    @refreshTable="refreshTable"
                    @end="requesting = false"
                ></form-edit-user>
                <notifications-form
                    v-if="displayManageNotifications"
                    ref="formNotifications"
                    :user="context.user"
                    :filter-scopes="filterFunction"
                    @refreshTable="refreshTable"
                ></notifications-form>
            </div>
            <span
                slot="footer"
                class="modal-actions"
            >
                <el-button
                    @click="close"
                >
                    {{ getVerbose('user_modal_edit_users_button_cancel') }}
                </el-button>
                <el-button
                    :loading="requesting"
                    type="primary"
                    @click="save"
                >
                    {{ getVerbose('user_modal_edit_users_button_save') }}
                </el-button>
            </span>
        </div>
    </el-dialog>
</template>

<script>
import FormEditUser from './form-edit-user.vue';
import NotificationsForm from '../../pages/user-profile/notifications-form.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        FormEditUser,
        NotificationsForm,
    },

    props: {
        windowWidth: {
            type: Number,
            required: true,
        },
        groups: {
            type: Array,
            required: true
        }
    },

    data: function(){
        return {
            context: null,
            dialogVisible: false,
            isEdit: false,
            requesting: false,
        };
    },

    computed: {
        ...mapGetters('fundation', [
            'userExtraEditableFields',
            'enableManageNotifications',
            'enableManageOtherUsersNotifications',
            'getScopeModelKey',
            'getVerbose'
        ]),
        displayManageNotifications() {
            return this.enableManageOtherUsersNotifications
                && this.enableManageNotifications
                && this.scopeModelKeyDefined;
        },
        scopeModelKeyDefined() {
            return this.getScopeModelKey.model !== '' && this.getScopeModelKey.key !== '';
        },
        titleDialog() {
            return this.context && Object.keys(this.context.user).length > 0 ? `${this.getVerbose('user_modal_edit_users_context_title_beginning')} ${this.context.user.verbose_name} ${this.getVerbose('user_modal_edit_users_context_title_end')}` : this.getVerbose('user_modal_edit_users_no_context_title');
        }
    },

    watch: {
        dialogVisible (val){
            if(val === false){
                this.requesting = false;
            }
        },
    },

    methods: {
        filterFunction(item) {
            return item.enable_notification;
        },
        refreshTable() {
            this.$emit('refreshTable');
        },
        open(context, isEdit){
            this.$set(this, 'context', context);
            this.isEdit = isEdit;
            this.dialogVisible = true;
        },
        close(){
            this.dialogVisible = false;
            this.$set(this, 'context', null);
        },
        async save() {
            this.requesting = true;
            let user = await this.$refs.formEditUser.saveUserProfile();
            if(this.displayManageNotifications) {
                this.$refs.formNotifications.saveNotificationsModifications(user);
            }
        },
    },
};
</script>

<style lang="scss">
.edit-user {
    .modal-actions {
        display: flex;
        justify-content: flex-end;
    }

    .el-switch {
        margin: 10px 0px;
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/usersManagement/user/modal-edit-user.vue